import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BinderAssembly } from 'src/app/models/binder-assembly.model';

@Injectable({
  providedIn: 'root'
})
export class AssemblyFinderService {
  assembly = signal<BinderAssembly | null>(null);

  constructor() { }

  setAssembly(assembly: BinderAssembly) {
    this.assembly.set(assembly);
  }

  clearAssembly() {
    this.assembly.set(null);
  }
}
